module.exports = __webpack_public_path__ + "static/media/millimetres2mountains-light.a582f1fd.png";